import ssrShortcodes from '../../scripts/constants/ssr-shortcodes';

class SSRRemarksUIModel {
  constructor({
    ssrCodes = [],
    isWheelchairRequested = false,
  } = {}) {
    this.ssrCodes = ssrCodes;
    this.isWheelchairRequested = ssrCodes.indexOf(ssrShortcodes.WHEELCHAIR) > -1 || isWheelchairRequested;
  }

  updateTravelerSSRRemarks(specialServicesRequired) {
    this.isWheelchairRequested = specialServicesRequired;
    this.ssrCodes = specialServicesRequired ? ['WCHR'] : [];
  }

  toApi() {
    return {
      '_meta':{
        'class':'SSRRemarks',
      },
      'ssrCodes': this.isWheelchairRequested ? ['WCHR'] : [],
    };
  }
}

export default SSRRemarksUIModel;
